import React from 'react';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Button,
} from '@mui/material';
import {
  Home,
  InsertChart,
  People,
  Assignment,
  Settings,
  Info,
  Feedback,
} from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';

const menuItems = [
  { text: 'Home', icon: <Home />, path: '/dashboard' },
  { text: 'Analytics', icon: <InsertChart />, path: '/analytics' },
  { text: 'Clients', icon: <People />, path: '/clients' },
  { text: 'Tasks', icon: <Assignment />, path: '/tasks' },
  { text: 'Settings', icon: <Settings />, path: '/settings' },
  { text: 'About', icon: <Info />, path: '/about' },
  { text: 'Feedback', icon: <Feedback />, path: '/feedback' },
];

const Sidenav = () => {
  const location = useLocation();

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 280,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 280,
          boxSizing: 'border-box',
          bgcolor: 'rgba(22, 28, 36, 0.94)',
          borderRight: '1px solid rgba(145, 158, 171, 0.24)',
        },
      }}
    >
      <Box sx={{ p: 3, pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
          <Typography variant="subtitle1" sx={{ color: 'rgb(255, 255, 255)', fontWeight: 700, fontSize: '1.125rem' }}>
            Sitemark-web
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ color: 'rgb(145, 158, 171)', fontSize: '0.875rem' }}>
          Web app
        </Typography>
      </Box>

      <List sx={{ px: 2 }}>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding sx={{ mb: 1 }}>
            <ListItemButton
              component={Link}
              to={item.path}
              selected={location.pathname === item.path}
              sx={{
                borderRadius: 1,
                color: 'rgb(145, 158, 171)',
                minHeight: 44,
                '&.Mui-selected': {
                  bgcolor: 'rgba(145, 158, 171, 0.16)',
                  color: 'rgb(255, 255, 255)',
                  '& .MuiListItemIcon-root': {
                    color: 'rgb(255, 255, 255)',
                  },
                },
                '&:hover': {
                  bgcolor: 'rgba(145, 158, 171, 0.08)',
                  color: 'rgb(255, 255, 255)',
                  '& .MuiListItemIcon-root': {
                    color: 'rgb(255, 255, 255)',
                  },
                },
              }}
            >
              <ListItemIcon 
                sx={{ 
                  color: 'inherit',
                  minWidth: 36,
                  '& .MuiSvgIcon-root': {
                    fontSize: 20,
                  },
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText 
                primary={item.text}
                primaryTypographyProps={{
                  fontSize: '0.875rem',
                  fontWeight: 600,
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      <Box sx={{ mt: 'auto', p: 2.5 }}>
        <Box sx={{ p: 2.5, bgcolor: 'rgba(145, 158, 171, 0.12)', borderRadius: 1 }}>
          <Typography 
            variant="subtitle2" 
            sx={{ 
              color: 'rgb(255, 255, 255)',
              fontWeight: 700,
              fontSize: '0.875rem',
              mb: 1 
            }}
          >
            Plan about to expire
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'rgb(145, 158, 171)',
              fontSize: '0.875rem',
              mb: 2 
            }}
          >
            Enjoy 10% off when renewing your plan today.
          </Typography>
          <Button 
            variant="outlined" 
            size="small" 
            fullWidth
            sx={{
              color: 'rgb(0, 184, 217)',
              borderColor: 'rgba(0, 184, 217, 0.24)',
              '&:hover': {
                borderColor: 'rgba(0, 184, 217, 0.32)',
                background: 'rgba(0, 184, 217, 0.08)',
              },
              textTransform: 'none',
              fontWeight: 700,
            }}
          >
            Get the discount
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidenav; 